module.exports = "<h1>Tree Folders</h1>\n<div>\n  <app-child-component [children]=\"data\"></app-child-component>\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/apache/localhost/www/Angular/task2/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = 1